/* eslint-disable import/prefer-default-export */
import { textBlockSimpleFragment } from 'legacy/graphql/fragments/sections/textBlockFragment';
import { simpleRichTextFragment } from 'legacy/graphql/fragments/components/simpleRichTextFragment';
import { listFragment } from 'legacy/graphql/fragments/primitives/listFragment';

export const disclosuresFragment = `
  ${listFragment(`${textBlockSimpleFragment}${simpleRichTextFragment}`, 10)}
`;
